module.exports = __webpack_public_path__ + "static/img/Tu1.ac92d68f.png";